import { render } from "./EditChangesItems.vue?vue&type=template&id=6f829926&scoped=true"
import script from "./EditChangesItems.vue?vue&type=script&lang=js"
export * from "./EditChangesItems.vue?vue&type=script&lang=js"

import "./EditChangesItems.vue?vue&type=style&index=0&id=6f829926&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f829926"]])

export default __exports__